
/* injects from baggage-loader */

import {combineReducers} from 'redux'
import modal from './modal'
import confirm from './confirm'
import toaster from './toaster'

export default combineReducers({
  modal,
  confirm,
  toaster
})



// WEBPACK FOOTER //
// ./client/redux/modules/ui/index.js